import { render, staticRenderFns } from "./ProdesResiduosPantanal.vue?vue&type=template&id=5875c224&lang=pug"
import script from "./ProdesResiduosPantanal.vue?vue&type=script&lang=js"
export * from "./ProdesResiduosPantanal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports